import widgetCRUDActions, {
  WidgetCreateParams,
} from '@mm/state/actions/WidgetCRUDActions';
import WidgetModel from '@mm/state/model/WidgetModel';
import { widgetsByDialogueSelector } from '@mm/state/selectors/widgetSelectors';
import { StoreState } from '@mm/state/store-interfaces';
import { cloneDeep, set } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { Dispatch } from 'redux';
import { arrangeWidgetSortOrder } from './arrange-widget-sort-order';

export const getFormatFromType = (type: string) => type.split('/').pop() || '';

export const useCommonWidgetHandlers = () => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  const widgets = useSelector((state: StoreState) => state.widget.entities);

  const deleteWidget = (widget: WidgetModel) => {
    dispatch(widgetCRUDActions.delete(widget, true));
  };

  const create = async (
    newWidget: WidgetCreateParams,
    dialogueId: number,
    sortOrder: number,
  ) => {
    const dialogueWidgets = widgetsByDialogueSelector(dialogueId, widgets);

    dispatch(widgetCRUDActions.createActionCreator(newWidget));

    if (dialogueWidgets.length) {
      const updatedWidgetList = arrangeWidgetSortOrder(
        sortOrder,
        dialogueWidgets,
      );
      await dispatch(
        widgetCRUDActions.batchUpdate(dialogueId, updatedWidgetList, {
          sortOrdersOnly: true,
        }),
      );
    }

    return dispatch(widgetCRUDActions.create(newWidget));
  };

  const update = async (updatedWidget: WidgetModel) => {
    return dispatch(widgetCRUDActions.update(updatedWidget));
  };

  const updateField = (
    widget: WidgetModel,
    path: string[] | string,
    value: any,
    callback?: () => void,
  ) => {
    const updatedWidget = cloneDeep(widget);
    set(updatedWidget, path, value);
    callback?.();
    return dispatch(widgetCRUDActions.update(updatedWidget));
  };

  const updateBodyText = (widget: WidgetModel, updatedText: string) => {
    updateField(widget, 'config.body', updatedText);
  };

  const updateAssetId = async (widget: WidgetModel, assetId: number | null) => {
    updateField(widget, 'config.assetId', assetId);
  };

  return {
    create,
    delete: deleteWidget,
    updateField,
    updateAssetId,
    updateBodyText,
    update,
  };
};
